/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".left[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{font-size:22px;font-weight:600;padding-bottom:15px;border-bottom:1px solid #d3d3d3}@media screen and (min-width:1280px){.left[_ngcontent-%COMP%]{box-shadow:none!important;background:0 0!important}}@media (max-width:1279px){.left[_ngcontent-%COMP%]{background-color:#fff!important}}@media screen and (max-width:1366px){.left[_ngcontent-%COMP%]{width:200px;min-width:200px}}"];
export { styles as styles };
